export const projectCardsComponentEnUS = {
  noProjectsAssigned: 'You have no projects assigned to you',
}

export const projectCardsComponentEsMX = {
  noProjectsAssigned: 'No tienes proyectos asignados',
}
